// Bilingual quiz data (EN / HI). Consumers should render with useLang().tr()
// The `id` values remain unchanged so backend answer schema stays intact.

export const quizSteps = [
  {
    id: 'gender',
    title: { en: 'Choose your gender', hi: 'अपना लिंग चुनें' },
    subtitle: { en: 'This helps us tailor your workout plan', hi: 'यह हमें आपका वर्कआउट प्लान तैयार करने में मदद करता है' },
    type: 'image-select',
    options: [
      { id: 'male', label: { en: 'Male', hi: 'पुरुष' }, image: 'https://images.pexels.com/photos/8874355/pexels-photo-8874355.jpeg' },
      { id: 'female', label: { en: 'Female', hi: 'महिला' }, image: 'https://images.unsplash.com/photo-1550345332-09e3ac987658' },
    ],
  },
  {
    id: 'body-type',
    title: { en: 'Choose your body type', hi: 'अपनी बॉडी टाइप चुनें' },
    type: 'image-select',
    options: [
      { id: 'skinny', label: { en: 'Skinny', hi: 'दुबला' }, image: 'https://images.unsplash.com/photo-1582439170934-d089aa10abda' },
      { id: 'average', label: { en: 'Average', hi: 'सामान्य' }, image: 'https://images.pexels.com/photos/20145958/pexels-photo-20145958.jpeg' },
      { id: 'heavy', label: { en: 'Heavy', hi: 'भारी' }, image: 'https://images.pexels.com/photos/8874414/pexels-photo-8874414.jpeg' },
      { id: 'muscular', label: { en: 'Muscular', hi: 'मस्कुलर' }, image: 'https://images.unsplash.com/photo-1610312856669-2cee66b2949c' },
    ],
  },
  {
    id: 'goal-body',
    title: { en: 'What is your dream body?', hi: 'आपकी सपनों की बॉडी कैसी है?' },
    type: 'image-select',
    options: [
      { id: 'lean', label: { en: 'Lean', hi: 'लीन' }, image: 'https://images.unsplash.com/photo-1582439170934-d089aa10abda' },
      { id: 'athletic', label: { en: 'Athletic', hi: 'एथलेटिक' }, image: 'https://images.pexels.com/photos/20145958/pexels-photo-20145958.jpeg' },
      { id: 'muscular-goal', label: { en: 'Muscular', hi: 'मस्कुलर' }, image: 'https://images.unsplash.com/photo-1610312856669-2cee66b2949c' },
    ],
  },
  {
    id: 'target-areas',
    title: { en: 'Select your target zones', hi: 'अपने लक्ष्य क्षेत्र चुनें' },
    subtitle: { en: 'Choose one or more areas to focus on', hi: 'ध्यान देने के लिए एक या अधिक क्षेत्र चुनें' },
    type: 'multi-select',
    options: [
      { id: 'chest', label: { en: 'Chest', hi: 'छाती' } },
      { id: 'arms', label: { en: 'Arms', hi: 'बाजू' } },
      { id: 'belly', label: { en: 'Belly', hi: 'पेट' } },
      { id: 'back', label: { en: 'Back', hi: 'पीठ' } },
      { id: 'legs', label: { en: 'Legs', hi: 'पैर' } },
      { id: 'shoulders', label: { en: 'Shoulders', hi: 'कंधे' } },
    ],
  },
  {
    id: 'fitness-level',
    title: { en: 'How would you describe your current fitness level?', hi: 'आप अपना वर्तमान फ़िटनेस स्तर कैसे बताएँगे?' },
    type: 'single-select',
    options: [
      { id: 'beginner', label: { en: 'Beginner', hi: 'शुरुआती' }, desc: { en: "I'm out of shape", hi: 'मेरी बॉडी शेप में नहीं है' } },
      { id: 'intermediate', label: { en: 'Intermediate', hi: 'मध्यम' }, desc: { en: 'I train occasionally', hi: 'मैं कभी-कभी ट्रेन करता/करती हूँ' } },
      { id: 'advanced', label: { en: 'Advanced', hi: 'उन्नत' }, desc: { en: 'I train regularly', hi: 'मैं नियमित ट्रेन करता/करती हूँ' } },
    ],
  },
  {
    id: 'workout-frequency',
    title: { en: 'How often do you exercise?', hi: 'आप कितनी बार व्यायाम करते हैं?' },
    type: 'single-select',
    options: [
      { id: 'never', label: { en: 'Almost never', hi: 'लगभग कभी नहीं' } },
      { id: 'sometimes', label: { en: '1-2 times per week', hi: 'सप्ताह में 1-2 बार' } },
      { id: 'often', label: { en: '3-5 times per week', hi: 'सप्ताह में 3-5 बार' } },
      { id: 'daily', label: { en: 'Every day', hi: 'प्रतिदिन' } },
    ],
  },
  {
    id: 'workout-location',
    title: { en: 'Where do you prefer to work out?', hi: 'आप कहाँ वर्कआउट करना पसंद करते हैं?' },
    type: 'single-select',
    options: [
      { id: 'home', label: { en: 'At home', hi: 'घर पर' } },
      { id: 'gym', label: { en: 'At the gym', hi: 'जिम में' } },
      { id: 'outdoor', label: { en: 'Outdoors', hi: 'बाहर' } },
      { id: 'anywhere', label: { en: 'Anywhere', hi: 'कहीं भी' } },
    ],
  },
  {
    id: 'diet',
    title: { en: 'Which type of diet do you prefer?', hi: 'आप किस प्रकार की डाइट पसंद करते हैं?' },
    type: 'single-select',
    options: [
      { id: 'traditional', label: { en: 'Traditional', hi: 'पारंपरिक' } },
      { id: 'vegetarian', label: { en: 'Vegetarian', hi: 'शाकाहारी' } },
      { id: 'vegan', label: { en: 'Vegan', hi: 'वीगन' } },
      { id: 'keto', label: { en: 'Keto based', hi: 'कीटो आधारित' } },
      { id: 'mediterranean', label: { en: 'Mediterranean', hi: 'मेडिटेरेनियन' } },
    ],
  },
  {
    id: 'water',
    title: { en: 'How much water do you drink daily?', hi: 'आप रोज़ कितना पानी पीते हैं?' },
    type: 'single-select',
    options: [
      { id: 'coffee', label: { en: 'Only coffee or tea', hi: 'केवल कॉफ़ी या चाय' } },
      { id: 'few', label: { en: 'Less than 2 glasses', hi: '2 गिलास से कम' } },
      { id: 'medium', label: { en: '2 to 6 glasses', hi: '2 से 6 गिलास' } },
      { id: 'plenty', label: { en: 'More than 6 glasses', hi: '6 गिलास से अधिक' } },
    ],
  },
  {
    id: 'sleep',
    title: { en: 'How many hours do you sleep?', hi: 'आप कितने घंटे सोते हैं?' },
    type: 'single-select',
    options: [
      { id: 'less5', label: { en: 'Less than 5 hours', hi: '5 घंटे से कम' } },
      { id: 'ok', label: { en: '5 to 6 hours', hi: '5 से 6 घंटे' } },
      { id: 'good', label: { en: '7 to 8 hours', hi: '7 से 8 घंटे' } },
      { id: 'lots', label: { en: 'More than 8 hours', hi: '8 घंटे से अधिक' } },
    ],
  },
  {
    id: 'measurements',
    title: { en: 'Enter your height & weight', hi: 'अपना कद व वज़न दर्ज करें' },
    type: 'measurements',
  },
  {
    id: 'target-weight',
    title: { en: 'What is your target weight?', hi: 'आपका लक्षित वज़न क्या है?' },
    type: 'target-weight',
  },
  {
    id: 'age',
    title: { en: 'How old are you?', hi: 'आपकी उम्र कितनी है?' },
    type: 'age-input',
  },
];

export const testimonials = [
  {
    name: { en: 'Michael, 34', hi: 'माइकल, 34' },
    result: { en: 'Lost 24 lbs in 3 months', hi: '3 महीनों में 24 lbs घटाए' },
    quote: {
      en: 'The workouts are challenging but doable. I feel stronger every week.',
      hi: 'वर्कआउट चुनौतीपूर्ण लेकिन संभव हैं। मैं हर सप्ताह मज़बूत महसूस करता हूँ।',
    },
  },
  {
    name: { en: 'Sarah, 29', hi: 'सारा, 29' },
    result: { en: 'Lost 18 lbs in 2 months', hi: '2 महीनों में 18 lbs घटाए' },
    quote: {
      en: 'I love that the plan adapts to my schedule. Best investment ever.',
      hi: 'मुझे अच्छा लगता है कि प्लान मेरे शेड्यूल के अनुसार ढल जाता है। सबसे बढ़िया निवेश।',
    },
  },
  {
    name: { en: 'James, 41', hi: 'जेम्स, 41' },
    result: { en: 'Gained 12 lbs of muscle', hi: '12 lbs मसल बढ़ाया' },
    quote: {
      en: 'Finally a program that works. The results speak for themselves.',
      hi: 'आख़िरकार एक ऐसा प्रोग्राम जो काम करता है। परिणाम खुद बोलते हैं।',
    },
  },
];

export const featuresList = [
  { en: 'Personalized workout plan', hi: 'व्यक्तिगत वर्कआउट प्लान' },
  { en: 'Custom nutrition guide', hi: 'कस्टम पोषण गाइड' },
  { en: 'Progress tracking', hi: 'प्रगति ट्रैकिंग' },
  { en: 'Expert trainer support', hi: 'विशेषज्ञ ट्रेनर सहायता' },
  { en: '24/7 access to workouts', hi: '24/7 वर्कआउट एक्सेस' },
  { en: 'Community & motivation', hi: 'समुदाय व प्रेरणा' },
];
